import { BsArrowRight } from '@react-icons/all-files/bs/BsArrowRight';
import { Link } from 'gatsby';
import type { FC } from 'react';
import type { CategoriesEntity } from '../../../@types/gql/home';
import SVGGradientFiller from '../../shared/svg-gradient-filler';
import './style.css';
import { SquareArrowOutUpRight } from 'lucide-react';

const CategoryCard: FC<CategoriesEntity> = ({
  PreviewIcon,
  // ShortDescription,
  Title,
  Slug,
}) => {
  return (
    <Link className="contents" to={Slug}>
      <div
        className="flex flex-col gap-2 px-5 py-4 items-center text-center
      hover:shadow-md transition-smooth hover:-translate-y-1.5 min-h-48 custom-gradient rounded-lg relative overflow-hidden h-full"
        id="product-card-hovered"
        // style={{ background: 'white' }}
        title={Title}
      >
         {/* <div className="ag-courses-item_bg"> </div> */}
        <div className="relative ml-3 mb-5">
          <div className="h-16 w-16 rounded-full relative bg-white" id="icon">
          <img
            alt="..."
            className="absolute top-[10px] left-[12px]"
            height={40}
            src={PreviewIcon.url}
            width={40}
          />
          </div>
        </div>

        <p className="font-bold text-xl text-white items-center">{Title}</p>
        {/* <p className="text-gray-500 font-light line-clamp-3" id="description">
        {..}
      </p> */}
        <Link
          className="flex flex-col space-x-1 items-center transition-smooth hover:-translate-y-1"
          to={Slug}
        >
          <span className="text-white text-sm items-center flex gap-2">
            KNOW MORE <SquareArrowOutUpRight size={15} className='text-white' />
          </span>
          {/* <SVGGradientFiller
            id="view-more-icon"
            stop={{ from: '#990400', via: '#FF3D00', to: '#FF8A00' }}
          />
          <BsArrowRight
            className="mt-px"
            style={{ fill: 'url(#view-more-icon)' }}
          /> */}
        </Link>
      </div>
    </Link>
  );
};

export default CategoryCard;
